<template>
<base-popup
    :popup-model="show"
    title="Live Link"
    :valid="!valid"
    save-button-text="Update"
    @onSaveButtonClick = "onUpdateHandler"
    @onCancelButtonClick="closeHandler"
>
  <v-textarea
      v-model="currentItem.liveLink"
      :rules="requiredFieldRule"
      label="Live Link"
      class="mt-5"
      dense
      outlined
  />
</base-popup>
</template>

<script>
import BasePopup from "./BasePopup";
import PopupMixin from "../mixins/Popup";
export default {
  name: "ViewLiveLink",
  mixins: [PopupMixin],
  components: {BasePopup},
  methods: {
    closeHandler() {
      this.$emit('closePopupHandler');
    },
    onUpdateHandler() {
      const siteUrl = this.currentItem.siteUrl;
      const linkArr = this.currentItem.liveLink.split("/");

      if(linkArr.length < 2) return;

      const linkSite = linkArr[2] ? linkArr[2] : '';

      if(linkSite !== siteUrl) {
        this.currentItem.liveLink = '';
        this.$store.commit('SET_SNACKBAR', {text: `You are selected this ${siteUrl} and your live link from ${linkSite} does not matched each other. Please check your live link`, type: 'error'})
        return;
      }

      this.$emit('onLinkUpdateHandler', {...this.currentItem});
    }
  }
}
</script>

<style scoped>

</style>